import { render, staticRenderFns } from "./navTab.vue?vue&type=template&id=0fd96f3b&scoped=true"
import script from "./navTab.vue?vue&type=script&lang=js"
export * from "./navTab.vue?vue&type=script&lang=js"
import style0 from "./navTab.vue?vue&type=style&index=0&id=0fd96f3b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd96f3b",
  null
  
)

export default component.exports